import styled, { css } from "styled-components/macro";

export const OptedInLeadsStyles = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  padding: 0 20px 20px 20px;
  height: calc(100vh - 224px);

  h3 {
    color: var(--Neutral-100);
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    letter-spacing: -0.3px;
  }

  .choose-opt-leads {
    display: flex;
    padding: 0 16px 0 16px;
    flex-direction: column;
    gap: 14px;
  }

  .data-wrapper {
    display: flex;
    align-items: stretch;
    flex-direction: column;
    gap: 24px;
    padding: 0 16px 16px 16px;

    .side-wrapper {
      display: flex;
      gap: 24px;

      .heading {
        color: var(--Neutral-60);
        font-size: 12px;
        font-weight: 500;
        line-height: 16px;
        letter-spacing: -0.18px;
      }

      p {
        color: var(--Neutral-100);
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        letter-spacing: -0.16px;
      }
    }
  }

  .error-text {
    font-size: 12px;
    color: var(--Error-100);
    line-height: 16px;
    letter-spacing: -0.012px;
  }

  label {
    color: var(--Neutral-60);
    font-weight: 500;
    display: flex;
    gap: 4px;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: -0.018px;
  }

  .side-wrapper-list {
    display: flex;
    flex: 1;
    flex-direction: column;
  }

  .toggle-label {
    margin-bottom: 6px;
    display: flex;
    gap: 4px;
    font-weight: 500;
    line-height: 12px;
    letter-spacing: -0.015px;
  }
`;

export const OptedField = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 6px;
  border-radius: 8px;
  border: 1px solid var(--Neutral-8);
  transition: all 0.2s ease-in-out;
  position: relative;
  padding: 8px;

  &.error {
    border: 1px solid var(--Error-100);
  }

  .field-wrapper {
    flex-wrap: wrap; /*allows multiple rows */
    gap: 6px;
    display: flex;
    width: 100%;

    svg {
      width: 14px;
      height: 14px;
    }
  }

  ${(props) =>
    props.size === "S" &&
    css`
      ${"" /* height: 32px; */}
      font-size: 14px;
      padding: 8px;
    `}

  ${(props) =>
    props.size === "M" &&
    css`
      ${"" /* height: 40px; */}
      font-size: 16px;
      padding: 10px;
    `}
  
       ${(props) =>
    !props.disabled &&
    css`
      &:focus-within {
        border: 1px solid var(--Neutral-80);
      }
    `}
  
       /* Disabled styles */
    ${(props) =>
    props.disabled &&
    css`
      background: var(
        --Neutral-4,
        linear-gradient(
          0deg,
          rgba(31, 31, 31, 0.04) 0%,
          rgba(31, 31, 31, 0.04) 100%
        ),
        #fff
      );
      cursor: not-allowed;
    `}
`;

export const OptedSearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  color: var(--Neutral-100);
  font-weight: 400;

  &:focus {
    outline: none;
    box-shadow: none;
  }

  &::placeholder {
    color: var(--Neutral-40);
  }

  ${(props) =>
    props.size === "S" &&
    css`
      font-size: 12px;
      line-height: 16px;
      letter-spacing: -0.012px;
    `}

  ${(props) =>
    props.size === "M" &&
    css`
      font-size: 14px;
      line-height: 20px;
      letter-spacing: -0.014px;
    `}
`;

export const OptedLeadChip = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  white-space: nowrap;
  flex-shrink: 0;
  padding: 0 4px;
  align-items: center;
  border-radius: 4px;
  background: var(
    --Neutral-8,
    linear-gradient(
      0deg,
      rgba(31, 31, 31, 0.08) 0%,
      rgba(31, 31, 31, 0.08) 100%
    ),
    #fff
  );

  h5 {
    color: var(--Neutral-100);
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: -0.014px;
  }

  span {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }
`;

export const FooterWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
`;
